import { IComponentOptions, IController } from "angular";

export class NoFilterResultsComponentCtrl implements IController {}

export const NoFilterResultsComponent: IComponentOptions = {
  templateUrl: require("./no-filter-results.jade"),
  controller: NoFilterResultsComponentCtrl,
};
